import { animate, state, style, transition, trigger } from '@angular/animations';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormArray, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatAutocomplete, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { PersonaService } from 'src/app/core/services/persona.service';
import { RecruiterService } from 'src/app/modules/recruiterpersona/services/recruiter.service';
import { ConfirmDialogModel, ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-event-skill-table',
  templateUrl: './event-skill-table.component.html',
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0', display: 'none' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
  styleUrls: ['./event-skill-table.component.scss'],
  standalone: false,
})
export class EventSkillTableComponent implements OnInit, OnChanges {
  @Input() serviceLineList;
  @Input() servLineArray;
  @Input() eventEdit;
  @Input() pastEvent;
  @Input() eventId;
  @Input() beforeSaveServ;
  @Output() addSkillObj: EventEmitter<any> = new EventEmitter<any>();
  @Output() deleteObj: EventEmitter<any> = new EventEmitter<any>();
  serviceDataList: any[];
  dataSource;
  columnsToDisplay = [
    'Skills',
    'Min Exp',
    'Max Exp',
    'Target',
    'Start Time',
    'No of Slots',
    'Auto Mapped',
    'Invite Sent',
    'Auto Confirmed',
    'Manual Confirmed',
    'Total Confirmed',
    'Gap',
    'editBtns',
  ];
  displayedColumns1: string[] = [
    'Skills',
    'Min Exp',
    'Max Exp',
    'Target',
    'Start Time',
    'No of Slots',
    'Auto Mapped',
    'Invite Sent',
    'Auto Confirmed',
    'Manual Confirmed',
    'Total Confirmed',
    'Gap',
    'editBtns',
  ];
  columnObjectMapper = {
    Skills: 'skills',
    'Min Exp': 'minExperience',
    'Max Exp': 'maxExperience',
    Target: 'target',
    'Auto Mapped': 'autoMapped',
    'Invite Sent': 'inviteSent',
    'Auto Confirmed': 'autoConfirmed',
    'Manual Confirmed': 'manualConfirmed',
    'Total Confirmed': 'totalConfirmed',
    Gap: 'gap',
    'Start Time': 'slotStartTime',
    'No of Slots': 'noOfSlots',
  };
  excel_columns = [
    'unitId',
    'unitCode',
    'unitDescription',
    'target',
    'autoMapped',
    'inviteSent',
    'autoConfirmed',
    'manualConfirmed',
    'totalConfirmed',
    'gap',
  ];
  skillExcel_column = [
    'skillId',
    'eventUnitId',
    'taxonomyPath',
    'eventInviteSent',
    'candidatesScheduled',
    'minExperience',
    'maxExperience',
    'target',
    'slotStartTime',
    'noOfSlots',
    'autoMapped',
    'inviteSent',
    'autoConfirmed',
    'manualConfirmed',
    'totalConfirmed',
    'gap',
  ];
  dataSource1;
  expandedElement: any;
  serviceLineListFiltered: any[];
  // serviceLineList: any[] = ['ADM', 'CCD', 'IS', 'BPOHR', 'ENG'];
  listOfServices: any[] = [];
  serviceControls: UntypedFormArray;
  skillControls: UntypedFormArray;
  skillDataList: any[];
  skills: any = [];
  selectedEvnetDetails: any;
  selectedSkillId: any;
  selectedSkillName: any;
  maxExperienceDropDown: number[] = [];
  experienceDropDown: number[] = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21];
  isEdit: boolean = false;
  serv: string;
  selectedUnitCode: any;
  eventEditVar: boolean = false;
  skillEdit: boolean;
  expandUnit: any = null;
  skillFormCtrl = new UntypedFormControl(null, Validators.required);
  @Input() excel_data: any[];
  excel_dataDownload: any[];
  startTimeDropDown = [];
  slotsDropDown = [];
  addOnBlur = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  chipCtrl = new UntypedFormControl();
  chips: any[] = [];
  selectedChip = [];
  @ViewChild('chipInput') chipInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto') matAutocomplete: MatAutocomplete;
  beforeEdit: any;

  constructor(
    private recruiterservice: RecruiterService,
    private router: Router,
    public confirmDialog: MatDialog,
    private _personaService: PersonaService,
  ) {}

  ngOnInit() {
    this.recruiterservice.getStartTimeSlots().subscribe(
      (res) => {
        this.startTimeDropDown = res;
      },
      (err) => {
        console.log(err);
      },
    );
    this.setTableData();
  }

  ngOnChanges() {
    console.log('serviceline', this.excel_data, this.servLineArray, this.serviceDataList);
    if (this.excel_data.length > 0) {
      this.excel_dataDownload = this.excel_data;
      console.log('exceldata', this.excel_dataDownload);
    }

    this.setTableData();
  }

  setTableData() {
    console.log('eventid--', this.eventId);
    if (!this.eventEdit) {
      this.skillFormCtrl = new UntypedFormControl(null, Validators.required);
      this.listOfServices = [];
      if (this.servLineArray) {
        this.servLineArray.forEach((element) => {
          element['skills'] = element['unitCode'];
          element['skillDetails'].forEach((item) => {
            item['skills'] = item['taxonomyPath'];
            item['isEditable'] = false;
            item['afterSaveEdit'] = false;
          });
        });
      } else {
        this.servLineArray = [];
      }
      this.serviceDataList = this.servLineArray;
      this.serviceDataList.forEach((ele, _index) => {
        ele['isEditable'] = false;
        if (!this.eventEdit && this.expandUnit && this.expandUnit == ele['unitCode']) {
          // console.log(this.expandUnit,ele['unitCode']);
          this.expandedElement = ele;
          this.setMiniTableData(ele);
        }
        this.listOfServices.push(ele.skills);
      });
      this.dataSource = new MatTableDataSource(this.serviceDataList);
      // this.excel_data=this.serviceDataList;
    }
  }

  setExpandedElement(element, column) {
    if (!this.skillEdit && column != 'Skills') {
      if (this.expandedElement == element) {
        if (!(column == 'editBtns' && !element.target)) {
          this.expandedElement = null;
        }
      } else {
        this.expandedElement = element;
      }
      // this.expandedElement == element ? this.expandedElement = null : this.expandedElement = element;
      this.setMiniTableData(element);
    }
  }

  setMiniTableData(element) {
    this.selectedUnitCode = element.skills;
    if (element.skillDetails) {
      element.skillDetails.forEach((ele) => {
        ele['isEditable'] = false;
      });
      this.skillDataList = element.skillDetails;
      this.dataSource1 = new MatTableDataSource(element.skillDetails);
    } else {
      this.skillDataList = [];
      this.dataSource1 = new MatTableDataSource([]);
    }
  }

  navigateTo(skill, unit, _field) {
    // if (field == 'serviceLine') {

    // }
    // else {

    // }
    if (!this.beforeSaveServ) {
      if (skill == null) {
        this.recruiterservice.setSkillUnit(false);
        this.recruiterservice.setSkillDetailsObj(unit.skillDetails);
        this.recruiterservice.setUnitIdController(unit.unitId);
      } else {
        this.recruiterservice.setSkillUnit(true);
        const skillarray: any[] = [];
        skillarray.push(skill);
        this.recruiterservice.setSkillDetailsObj(skillarray);
        this.recruiterservice.setUnitIdController(unit.unitId);
      }
      console.log('pgate to', skill, unit, unit.skillDetails);
      this.recruiterservice.setEventControllerTabIndex(0);
      this.router.navigate(['recruiter/eventController']);
    }
  }

  getControl(index, fieldName, tableName) {
    if (tableName == 'serviceTable') {
      return this.serviceControls.at(index).get(fieldName) as UntypedFormControl;
    } else {
      return this.skillControls.at(index).get(fieldName) as UntypedFormControl;
    }
  }

  buildFormarray(tableName, data) {
    const toGroups = data.map((entity, _index) => {
      return new UntypedFormGroup(
        {
          skills: new UntypedFormControl(entity.skills, Validators.required),
          minExperience:
            tableName == 'serviceTable'
              ? new UntypedFormControl(entity.minExperience)
              : new UntypedFormControl(entity.minExperience, Validators.required),
          maxExperience:
            tableName == 'serviceTable'
              ? new UntypedFormControl(entity.maxExperience)
              : new UntypedFormControl(entity.maxExperience, Validators.required),
          target:
            tableName == 'serviceTable'
              ? new UntypedFormControl(entity.target)
              : new UntypedFormControl(entity.target, Validators.required),
          slotStartTime: new UntypedFormControl(entity.slotStartTime),
          noOfSlots: new UntypedFormControl(entity.noOfSlots),
          autoMapped: new UntypedFormControl(entity.autoMapped),
          inviteSent: new UntypedFormControl(entity.inviteSent),
          autoConfirmed: new UntypedFormControl(entity.autoConfirmed),
          manualConfirmed: new UntypedFormControl(entity.manualConfirmed),
          totalConfirmed: new UntypedFormControl(entity.autoConfirmed),
          gap: new UntypedFormControl(entity.autoConfirmed),
        },
        { updateOn: 'blur' },
      );
    });
    if (tableName == 'serviceTable') {
      this.serviceControls = new UntypedFormArray(toGroups);
    } else {
      this.skillControls = new UntypedFormArray(toGroups);
    }
  }

  addServiceRow() {
    if (!this.isEdit) {
      this.serviceDataList.unshift({
        skills: null,
        minExperience: null,
        maxExperience: null,
        target: null,
        autoMapped: null,
        inviteSent: null,
        autoConfirmed: null,
        manualConfirmed: null,
        totalConfirmed: null,
        gap: null,
        dataSource: [],
        isEditable: true,
      });
      this.isEdit = true;
      this.dataSource.data = this.serviceDataList;
      this.expandedElement = this.serviceDataList[0];
      this.buildFormarray('serviceTable', this.serviceDataList);
      if (document.getElementById('header-Skills')) {
        document.getElementById('header-Skills').scrollIntoView();
      }
    }
  }

  onTypeServiceLine(_typedService) {
    this.serviceLineListFiltered = [];
    const tempVal = (document.getElementById('slInput') as HTMLInputElement).value;
    // console.log(typedService, tempVal);
    const typedServiceLine = tempVal;
    if (typedServiceLine != undefined && typedServiceLine != null) {
      const _serviceLineKeyword = typedServiceLine;
      if (!typedServiceLine.length && typedServiceLine !== undefined && typedServiceLine != null) {
        this.serviceLineListFiltered = [];
      } else {
        //response returns the all city list from venue table
        this.serviceLineList.forEach((value) => {
          // for each value we try match the typed string with city name
          if (value.toLowerCase().startsWith(typedServiceLine.toLowerCase())) {
            this.serviceLineListFiltered.push(value);
            this.serviceLineListFiltered.sort();
            // console.log("!!!", this.serviceLineListFiltered);
          }
          //if city name matched we push in venueCitiesArray
          //console.log("!!!",this.serviceLineListFiltered);
        });
      }
    }
  }

  addServiceLine(unitSelected) {
    // console.log('sat', unitSelected);
    if (this.listOfServices.find((x) => x == unitSelected) !== undefined) {
      this._personaService.openSnackBar({ msg: 'Service Line is already added', isSuccess: true }, 'success-snack');
      // alert('Service Line is already added');
      const serviceLine = this.getControl(0, 'skills', 'serviceTable');
      serviceLine.setValue(null);
    }
  }

  addService(element, index) {
    if (!this.eventEdit) {
      if (
        this.serviceControls.value[index].skills != '' &&
        this.serviceControls.value[index].skills != null &&
        this.serviceControls.value[index].skills != undefined
      ) {
        if (this.serviceLineListFiltered.indexOf(this.serviceControls.value[index].skills) != -1) {
          console.log(this.serviceControls.value[index]);
          element.skills = this.serviceControls.value[index].skills;
          this.selectedUnitCode = this.serviceControls.value[index].skills;
          element.isEditable = false;
          console.log(this.dataSource.data);
          this.isEdit = false;
          this.serviceLineListFiltered = [];
          this.selectedUnitCode = this.serviceControls.value[index].skills;
        } else {
          this._personaService.openSnackBar(
            { msg: 'Please select value from dropdown', isSuccess: true },
            'success-snack',
          );
        }
      } else {
        this.serviceControls.at(index).markAllAsTouched();
      }
    }
  }

  removeService(element, index) {
    this.serviceLineListFiltered = [];
    this.serviceDataList.splice(index, 1);
    this.dataSource.data = this.serviceDataList;
    this.isEdit = false;
  }

  deleteService(element, index) {
    if (!this.eventEdit) {
      const messageReject = 'Are you sure you want to delete this Service Line ?';
      const dialogData = new ConfirmDialogModel(messageReject, '');
      const dialogRef = this.confirmDialog.open(ConfirmDialogComponent, { maxWidth: '400px', data: dialogData });
      dialogRef.afterClosed().subscribe((dialogResultReject) => {
        if (dialogResultReject) {
          if (this.beforeSaveServ) {
            this.serviceDataList.splice(index, 1);
            this.dataSource.data = this.serviceDataList;
          } else {
            this.deleteObj.emit({ eventUnitId: 0, table: 'serviceLine', unitCode: element.skills });
          }
        }
      });
    }
  }

  addSkillRow() {
    if (!this.isEdit) {
      this.skillEdit = true;
      this.skillDataList.unshift({
        skills: null,
        minExperience: null,
        maxExperience: null,
        target: null,
        slotStartTime: null,
        noOfSlots: null,
        autoMapped: null,
        inviteSent: null,
        autoConfirmed: null,
        manualConfirmed: null,
        totalConfirmed: null,
        gap: null,
        dataSource: [],
        isEditable: true,
        afterSaveEdit: false,
      });
      console.log(this.skillDataList);
      this.isEdit = true;
      this.dataSource1.data = this.skillDataList;
      this.selectedChip = [];
      this.chips = [];
      this.buildFormarray('skillTable', this.skillDataList);
      if (document.getElementById('scrollPoint')) {
        document.getElementById('scrollPoint').scrollIntoView();
      }
    }
  }

  onTypegetSkill(_event) {
    // let val = (document.getElementById("skInput") as HTMLInputElement).value;
    if (this.selectedChip.length == 3) {
      this.chipInput.nativeElement.value = '';
    } else {
      this.skills = [];
      const val = this.skillFormCtrl.value;
      console.log('!!!V', val);
      const skillKeyword = val.toString().trim();
      if (
        !skillKeyword.length &&
        skillKeyword !== undefined &&
        skillKeyword != null &&
        typeof skillKeyword === 'string'
      ) {
        this.skills = [];
      }
      if (typeof val === 'string') {
        this.recruiterservice.getSkillDetails(val.toLowerCase()).subscribe((skillElastic) => {
          this.skills = skillElastic;
        });
      }
    }
  }

  displaySkillFn(skill) {
    if (this.selectedEvnetDetails) {
      return this.selectedEvnetDetails.skillId;
    }
    if (skill) {
      this.selectedSkillId = skill.skill_id;
      this.selectedSkillName = skill.skill_name;
      return skill ? skill.skill_name : this.selectedEvnetDetails.skillId;
    }
  }

  setValueInTooltip(skillName: string) {
    if (skillName.length > 20) {
      return skillName;
    } else {
      return null;
    }
  }

  changeMaxExp(minExp) {
    this.maxExperienceDropDown = null;
    //console.log('isssues',minExp);
    if (minExp === 21) {
      this.maxExperienceDropDown = [minExp];
      //console.log('isssues if',this.maxExperienceDropDown);
    } else {
      // indexOf === minExp, so slice
      this.maxExperienceDropDown = this.experienceDropDown.slice(minExp + 1, this.experienceDropDown.length);
      //console.log('isssues',this.maxExperienceDropDown);
    }
  }

  addSkill(element, index) {
    if (!this.eventEdit) {
      if (element.isEditable) {
        if (
          this.selectedChip.length > 0 &&
          this.skillControls.value[index].minExperience >= 0 &&
          this.skillControls.value[index].maxExperience &&
          this.skillControls.value[index].target
        ) {
          element.skills = this.chips[0];
          element.minExperience = this.skillControls.value[index].minExperience;
          element.maxExperience = this.skillControls.value[index].maxExperience;
          element.target = this.skillControls.value[index].target;
          element.slotStartTime = this.skillControls.value[index].slotStartTime;
          element.noOfSlots = this.skillControls.value[index].noOfSlots;
          element.isEditable = false;
          this.isEdit = false;
          this.skillEdit = false;
          const tempSlotTime = this.skillControls.value[index].slotStartTime
            ? this.skillControls.value[index].slotStartTime.split('-')[0]
            : null;
          const addSklObj = [
            {
              eventUnitId: 0,
              unitCode: this.selectedUnitCode,
              skillIds: this.selectedChip,
              minExp: this.skillControls.value[index].minExperience,
              maxExp: this.skillControls.value[index].maxExperience,
              target: this.skillControls.value[index].target,
              slotStartTime: tempSlotTime,
              noOfSlots: this.skillControls.value[index].noOfSlots,
            },
          ];
          this.skills = [];
          this.expandedElement = null;
          this.expandUnit = this.selectedUnitCode;
          this.addSkillObj.emit(addSklObj);
        } else {
          this.skillControls.at(index).markAllAsTouched();
          this.skillFormCtrl.setErrors({ required: true });
        }
      }
      if (element.afterSaveEdit) {
        if (this.beforeSaveServ) {
          element.slotStartTime = this.skillControls.value[index].slotStartTime
            ? this.skillControls.value[index].slotStartTime.split('-')[0]
            : null;
          element.noOfSlots = this.skillControls.value[index].noOfSlots;
          element.afterSaveEdit = false;
          this.isEdit = false;
          this.skillEdit = false;
        } else {
          // if(this.skillControls.value[index].slotStartTime && this.skillControls.value[index].noOfSlots){
          if (
            this.skillControls.value[index].slotStartTime &&
            (this.beforeEdit.slotStartTime != this.skillControls.value[index].slotStartTime.split('-')[0] ||
              this.beforeEdit.noOfSlots != this.skillControls.value[index].noOfSlots)
          ) {
            // if (this.skillControls.value[index].noOfSlots) {
            element.slotStartTime = this.skillControls.value[index].slotStartTime;
            element.noOfSlots = this.skillControls.value[index].noOfSlots;
            element.afterSaveEdit = false;
            this.isEdit = false;
            this.skillEdit = false;
            const tempSlotTime = this.skillControls.value[index].slotStartTime
              ? this.skillControls.value[index].slotStartTime.split('-')[0]
              : null;
            const addSklObj = [
              {
                eventUnitId: element.eventUnitId,
                unitCode: this.selectedUnitCode,
                skillIds: this.skillDataList[index]['skillId'],
                minExp: this.skillControls.value[index].minExperience,
                maxExp: this.skillControls.value[index].maxExperience,
                target: this.skillControls.value[index].target,
                slotStartTime: tempSlotTime,
                noOfSlots: this.skillControls.value[index].noOfSlots,
              },
            ];
            // console.log(addSklObj);
            this.expandedElement = null;
            this.expandUnit = this.selectedUnitCode;
            this.addSkillObj.emit(addSklObj);
            // }
          } else {
            element.afterSaveEdit = false;
            element.slotStartTime = this.beforeEdit.slotStartTime;
            this.isEdit = false;
            this.skillEdit = false;
          }
        }
      }
    }
  }

  removeSkill(element, index) {
    if (element.afterSaveEdit) {
      this.beforeEdit['afterSaveEdit'] = false;
      this.skillDataList[index] = this.beforeEdit;
      this.dataSource1.data = this.skillDataList;
      this.isEdit = false;
      this.skillEdit = false;
      this.beforeEdit = null;
    } else {
      this.skills = [];
      this.skillDataList.splice(index, 1);
      this.dataSource1.data = this.skillDataList;
      this.isEdit = false;
      this.skillEdit = false;
      this.skillFormCtrl.setValue(null);
      this.selectedChip = [];
      this.chips = [];
    }
  }

  deleteSkill(element, index) {
    if (!this.eventEdit) {
      const messageReject = 'Are you sure you want to delete this Skill ?';
      const dialogData = new ConfirmDialogModel(messageReject, '');
      const dialogRef = this.confirmDialog.open(ConfirmDialogComponent, { maxWidth: '400px', data: dialogData });
      dialogRef.afterClosed().subscribe((dialogResultReject) => {
        if (dialogResultReject) {
          if (this.beforeSaveServ) {
            this.skillDataList.splice(index, 1);
            this.dataSource1.data = this.skillDataList;
          } else {
            this.deleteObj.emit({ eventUnitId: element.eventUnitId, table: 'skill' });
          }
        }
      });
    }
  }

  remove(chip) {
    // console.log("chip -- ", chip)
    const index = this.chips.indexOf(chip);
    if (index >= 0) {
      this.chips.splice(index, 1);
      this.selectedChip.splice(index, 1);
    }
  }

  add(event: MatChipInputEvent): void {
    // Add Chips only when MatAutocomplete is not open
    // To make sure this does not conflict with OptionSelected Event
    if (!this.matAutocomplete.isOpen) {
      const input = event.input;
      const value = event.value;
      console.log('filteredchips----', this.skills);
      if (this.skills) {
        const data = this.skills.find((x) => x.skill_name == value);
        // Add our Chip
        if (data) {
          if ((value || '').trim()) {
            // this.chips.push(data);
          }
        }
        // Reset the input value
        if (input) {
          input.value = '';
        }
      }
      this.skillFormCtrl.setValue(null);
    } else {
      const input = event.input;
      if (input) {
        input.value = '';
      }
    }
  }

  addSelectedSkill(event: MatAutocompleteSelectedEvent): void {
    const selectedVal = this.skills.find((res) => res.skill_name === event.option.value);
    // let skilFlag = true;
    // this.skillDataList.forEach(ele => {
    //   if (ele['skillId'] && ele['skillId'].indexOf(selectedVal['skill_id']) != -1) {
    //     skilFlag = false;
    //   }
    // })
    if (this.selectedChip.indexOf(selectedVal['skill_id']) == -1) {
      this.selectedChip.push(selectedVal.skill_id);
      this.chips.push(event.option);
      console.log('event.option', event.option);
      this.chipInput.nativeElement.value = '';
      this.skillFormCtrl.setValue(null);
      this.skills = [];
    } else {
      this._personaService.openSnackBar({ msg: 'Skill is already added', isSuccess: true }, 'success-snack');
      this.skillFormCtrl.setValue(null);
      this.skills = [];
    }
  }

  editSkills(element, _ind) {
    if (!this.eventEdit && !this.skillEdit) {
      this.skillEdit = true;
      this.isEdit = true;
      this.beforeEdit = JSON.parse(JSON.stringify(element));
      element['afterSaveEdit'] = true;
      this.startTimeDropDown.forEach((ele) => {
        if (ele.slotTime.split('-')[0] === element['slotStartTime']) {
          this.slotsDropDown = [];
          for (let i = 1; i <= ele.slotLeft; i++) {
            this.slotsDropDown.push(i);
          }
          element['slotStartTime'] = ele.slotTime;
        }
      });
      this.buildFormarray('skillTable', this.skillDataList);
    }
  }

  setNoOfSlots(event, index) {
    // console.log(event);
    this.skillControls.at(index).get('noOfSlots').setValue(null);
    this.startTimeDropDown.forEach((ele) => {
      if (ele.slotTime == event) {
        this.slotsDropDown = [];
        for (let i = 1; i <= ele.slotLeft; i++) {
          this.slotsDropDown.push(i);
        }
      }
    });
  }
}
